import * as queryString from 'query-string'
import * as React from 'react'

import { IStudioRecommendations } from '../../../typings/studioRecommendations'

interface IProps {
  config: IStudioRecommendations
  currentSite: string
  category: string
  term: string
}

const StudioRecommendationsBanner = ({
  config,
  currentSite,
  category,
  term
}: IProps) => {
  const items = config.items
  const generation = config.generation

  const getLinkParams = (itemId: number) => {
    const params = {
      utm_campaign: 'shervinator',
      utm_source: 'marketplace',
      utm_medium: currentSite,
      utm_term: category || term,
      utm_content: `${generation}_${items.map(item => item.id).join('_')}_${
        itemId
      }`
    }

    const queries = queryString.stringify(params)
    return queries
  }

  return (
    <div className="studio-recommendations fds-u-mb4 fds-u-p1">
      <a
        className="studio-recommendations__logo fds-u-m1 fds-u-mb2"
        href="https://studio.envato.com/"
      />
      <div className="studio-recommendations__list">
        <ul className="fds-c-text-list -style-none">
          {items.map(item => (
            <li className="fds-c-text-body fds-u-m1" key={item.id}>
              <a
                href={item.url + '?' + getLinkParams(item.id)}
                className="fds-c-text-link -decoration-reversed"
              >
                {item.name}
              </a>{' '}
              from ${item.price_from}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default StudioRecommendationsBanner



// WEBPACK FOOTER //
// ./client/components/banners/studioRecommendationsBanner.tsx